import { render, staticRenderFns } from "./authEmail.vue?vue&type=template&id=32678104&scoped=true"
import script from "./authEmail.vue?vue&type=script&lang=js"
export * from "./authEmail.vue?vue&type=script&lang=js"
import style0 from "./authEmail.vue?vue&type=style&index=0&id=32678104&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32678104",
  null
  
)

export default component.exports